import ISchedulerListEntry from '../interfaces/ISchedulerListEntry';

type Constructor = abstract new (...args: any[]) => ISchedulerListEntry;
export default function BaseSchedulerListEntryMixin<TBase extends Constructor>(Base: TBase) {
  abstract class BaseSchedulerListEntryClass extends Base {

  }
  return BaseSchedulerListEntryClass;
}
